import React, { useState } from "react";
import styles from "../styles/UlcPremiumCalculator.module.css";

const IndividualPlotOwnerForm = () => {
  const [formData, setFormData] = useState({
    district: "",
    taluka: "",
    village: "",
    surveyNumber: "",
    area: "",
    rrRate: "",
  });

  const [premium, setPremium] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Allow '/' in Survey Number, numbers and decimals for Area, numbers only for RR Rate
    if (name === "surveyNumber") {
      setFormData({ ...formData, [name]: value });
    } else if (name === "area") {
      if (/^\d*\.?\d{0,2}$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }
    } else if (name === "rrRate") {
      if (/^\d*$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const area = parseFloat(formData.area);
    const rrRate = parseFloat(formData.rrRate);

    if (!isNaN(area) && !isNaN(rrRate)) {
      const result = area * rrRate * 0.1;
      setPremium(result.toFixed(2));
    } else {
      setPremium("Invalid input");
    }
  };

  return (
    <form className={styles.calculatorULC_form} onSubmit={handleSubmit}>
      <div className={styles.calculatorULC_inputGroup}>
        <label>District</label>
        <select
          name="district"
          className={styles.calculatorULC_input}
          value={formData.district}
          onChange={handleChange}
        >
          <option value="">Select District</option>
          <option value="Kolhapur">Kolhapur</option>
          <option value="Mumbai">Mumbai</option>
          <option value="Nagpur">Nagpur</option>
          <option value="Nashik">Nashik</option>
          <option value="Pune">Pune</option>
          <option value="Sangli">Sangli</option>
          <option value="Solapur">Solapur</option>
          <option value="Thane">Thane</option>
          <option value="Ulhasnagar">Ulhasnagar</option>

        </select>
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Taluka</label>
        <input
          type="text"
          name="taluka"
          className={styles.calculatorULC_input}
          placeholder="Enter Taluka"
          value={formData.taluka}
          onChange={handleChange}
        />
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Village</label>
        <input
          type="text"
          name="village"
          className={styles.calculatorULC_input}
          placeholder="Enter Village"
          value={formData.village}
          onChange={handleChange}
        />
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Survey Number</label>
        <input
          type="text"
          name="surveyNumber"
          className={styles.calculatorULC_input}
          placeholder="Enter Survey Number (e.g. 122/4B/3C)"
          value={formData.surveyNumber}
          onChange={handleChange}
        />
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>Area of Plot (m²)</label>
        <input
          type="text"
          name="area"
          className={styles.calculatorULC_input}
          placeholder="Enter Area"
          value={formData.area}
          onChange={handleChange}
        />
      </div>

      <div className={styles.calculatorULC_inputGroup}>
        <label>
          Ready Reckoner Rate (Rs/m²){" "}
          <a
            href="https://www.igrmaharashtra.gov.in/eASR/.frmMap.aspx"
            target="_blank"
            rel="noopener noreferrer"
          >
            (Check RR Rate)
          </a>
        </label>
        <input
          type="text"
          name="rrRate"
          className={styles.calculatorULC_input}
          placeholder="Enter Rate"
          value={formData.rrRate}
          onChange={handleChange}
        />
      </div>

      <button type="submit" className={styles.calculatorULC_submitButton}>
        Submit
      </button>

      {premium && (
        <div className={styles.calculatorULC_inputGroup}>
          <label>ULC Premium Amount (₹)</label>
          <input
            type="text"
            readOnly
            className={styles.calculatorULC_input}
            value={premium}
          />
        </div>
      )}
    </form>
  );
};

export default IndividualPlotOwnerForm;
